import { FC } from "react";
import { useBrandName } from "@/hooks/useBrandName";

interface SuccessStepProps {
  amountLabel: string;
  onClose: () => void;
}

export const SuccessStep: FC<SuccessStepProps> = ({ amountLabel, onClose }) => {
  const brandName = useBrandName();
  return (
    <>
      {/* Success icon */}
      <div className="w-16 h-16 rounded-full bg-sr-mint/20 flex items-center justify-center">
        <div className="w-10 h-10 rounded-full bg-sr-mint flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12L10 17L19 7"
              stroke="#170B10"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {/* Header */}
      <div className="flex flex-col gap-2 items-center text-center">
        <h1 className="text-2xl sm:text-4xl font-medium text-white">
          Deposit complete
        </h1>
        <p className="text-sm sm:text-base text-sr-pink-muted">
          {amountLabel} is now available in your {brandName} account
        </p>
      </div>

      {/* Summary */}
      <div className="sr-highlight-box w-full">
        <div className="flex flex-col gap-1.5">
          <p className="text-base font-medium text-sr-pink-light">
            You're all set
          </p>
          <p className="text-xs text-sr-pink-bright">
            Your funds are now available on the {brandName} L2. Stay tuned!
          </p>
        </div>
      </div>

      {/* CTA */}
      <button className="sr-btn-primary" onClick={onClose}>
        Done
      </button>
    </>
  );
};
